import { render, staticRenderFns } from "./Stepper.vue?vue&type=template&id=3afa6e85&scoped=true&"
import script from "./Stepper.vue?vue&type=script&lang=js&"
export * from "./Stepper.vue?vue&type=script&lang=js&"
import style0 from "./Stepper.vue?vue&type=style&index=0&id=3afa6e85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afa6e85",
  null
  
)

export default component.exports